<script>
import moment from "moment";
import { WINDOW_TIME_TO } from "@/modules/checkin-facility/utils/checkinTimeWindow";

export default {
   name: 'facilityCheckinOperation',
   data() {
      return {
         showSuccess: false,
         checkinSettingData: {
            from: '00:00',
            to: '23:59',
            date_restriction: false,
            window_time: 0,
            facility_id: window._app_facility.id
         },
         windowTimeOptions: [0, 1, 2, 3, 4],
         checkinFromTimingList: [],
         checkinToTimingList: [],
         isInvalidCheckinTimeSetting: false,
         invalidCheckinTimeSettingErrorMessage: '',
         timeZone: 'Asia/Tokyo',
      }
   },
   computed: {
      isWindowTimeAvailable() {
         return this.checkinSettingData.to === WINDOW_TIME_TO;
      }
   },
   async mounted() {
      await this.getCheckinSettings();
   },
   methods: {
      async getCheckinSettings() {
         const response = await this.$lionheart.get(
            '/v2/facility-settings/checkin-operation-settings',
            { params: { facility_id: window._app_facility.id } }
         );
         const data = response.data.data;
         this.checkinSettingData.from = data.from ?? '00:00';
         this.checkinSettingData.to = data.to ?? '23:59';
         this.checkinSettingData.date_restriction = data.date_restriction ?? false;
         this.checkinSettingData.window_time = data.window_time ?? 0;
         if (data.timeZone) this.timeZone = data.timeZone;

         const fromList = [...data.checkinTimings];
         const toList = [...data.checkinTimings];
         fromList.pop();
         toList.shift();
         this.checkinFromTimingList = fromList;
         this.checkinToTimingList = toList;
      },

      async submitForm() {
         this.validateCheckinTiming();
         if (this.isInvalidCheckinTimeSetting) {
            setTimeout(() => {
               this.isInvalidCheckinTimeSetting = false;
            }, 3000);
            return;
         }
         await this.updateCheckinTimingSettings();
      },

      validateCheckinTiming() {
         const fromTime = this.checkinSettingData.from;
         const toTime = this.checkinSettingData.to;
         if (fromTime == '00:00' && this.checkinSettingData.to != '23:59') this.isInvalidCheckinTimeSetting = true;
         if (fromTime != '00:00' && this.checkinSettingData.to == '23:59') this.isInvalidCheckinTimeSetting = true;
         this.invalidCheckinTimeSettingErrorMessage = this.$t('account_page_facility_checkin_operation.error_message');
         if (moment(fromTime, 'HH:mm').unix() > moment(toTime, 'HH:mm').unix()) {
            this.invalidCheckinTimeSettingErrorMessage = this.$t('account_page_facility_checkin_operation.error_invalid_time_selection');
            this.isInvalidCheckinTimeSetting = true;
         }
      },

      async updateCheckinTimingSettings() {
         const response = await this.$lionheart.put(
            '/v2/facility-settings/update-checkin-operation-settings',
            this.checkinSettingData
         );
         if (response.status === 200) {
            this.showSuccess = true;
            await this.getCheckinSettings();
            setTimeout(() => {
               this.showSuccess = false;
            }, 3000);
         }
      },

      isAnyFromCheckinTime(time) {
         return time == '00:00' ? this.$t('account_page_facility_checkin_operation.checkin_setting_anytime_label') : time;
      },
      isAnyToCheckinTime(time) {
         return time == '23:59' ? this.$t('account_page_facility_checkin_operation.checkin_setting_anytime_label') : time;
      },
      haveTimezone(time) {
         return time == '00:00' || time == '23:59' ? '' : this.timeZone;
      },
      onCheckinToChange() {
         if (!this.isWindowTimeAvailable) this.checkinSettingData.window_time = 0;
      },
      windowTimeLabel(hours) {
         return hours === 0
            ? this.$t('account_page_facility_checkin_operation.window_time_none')
            : this.$tc('account_page_facility_checkin_operation.window_time_next_day', hours, { hours });
      }
   }
}
</script>
<template>
   <section>

      <div class="card-header py-3">
         <p>{{ $t('account_page_facility_checkin_operation.checkin_operation_note_text') }}</p>
      </div>

      <div class="card-body">
         <!-- success message -->
         <div class="alert alert-success alert-dismissible" role="alert" v-if="showSuccess">
            {{ $t('account_page_facility_checkin_operation.success_message') }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
               <span aria-hidden="true">&times;</span>
            </button>
         </div>
         <!-- invalid timing setting -->
         <div class="alert alert-danger alert-dismissible" role="alert" v-if="isInvalidCheckinTimeSetting">
            {{ invalidCheckinTimeSettingErrorMessage }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
               <span aria-hidden="true">&times;</span>
            </button>
         </div>

         <form @submit.prevent="submitForm">
            <!-- Check-in Time form -->
            <div>
               <h5>{{ $t('account_page_facility_checkin_operation.checkin_setting_title') }}</h5>
               <p>{{ $t('account_page_facility_checkin_operation.checkin_setting_description_text') }}</p>
            </div>

            <div class="container">
               <div class="row ">
                  <div class="col-lg-3">
                     <label class="col-form-label">
                        {{ $t('account_page_facility_checkin_operation.checkin_setting_label_name') }}
                     </label>
                  </div>
                  <div class="col-lg-9 col-md-12 col-sm-12">
                     <div class="form-group row">
                        <label for="" class="col-form-label"> {{ $t('account_page_facility_checkin_operation.checkin_setting_from') }}:</label>
                        <div class="col-sm-4">
                           <select class="form-control" v-model="checkinSettingData.from">
                              <option
                                 v-for="(time, key) in checkinFromTimingList"
                                 :value="time"
                                 :key="key"
                              > {{ isAnyFromCheckinTime(time) }} {{ haveTimezone(time) }}
                              </option>
                           </select>
                        </div>

                        <label for="" class="col-form-label"> {{ $t('account_page_facility_checkin_operation.checkin_setting_to') }}:</label>
                        <div class="col-sm-4">
                           <select class="form-control" v-model="checkinSettingData.to" @change="onCheckinToChange">
                              <option
                                 v-for="(time, key) in checkinToTimingList"
                                 :value="time"
                                 :key="key"
                              > {{ isAnyToCheckinTime(time) }} {{ haveTimezone(time) }}
                              </option>
                           </select>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="row">
                  <div class="col-lg-3">
                     <label class="col-form-label">
                        {{ $t('account_page_facility_checkin_operation.window_time_label') }}
                     </label>
                  </div>
                  <div class="col-lg-9 col-md-12 col-sm-12">
                     <div class="form-group row">
                        <!-- invisible "From:" spacer so this dropdown lines up with the From dropdown above -->
                        <label class="col-form-label invisible" aria-hidden="true"> {{ $t('account_page_facility_checkin_operation.checkin_setting_from') }}:</label>
                        <div class="col-sm-4">
                           <select
                              class="form-control"
                              v-model.number="checkinSettingData.window_time"
                              :disabled="!isWindowTimeAvailable"
                           >
                              <option
                                 v-for="hours in windowTimeOptions"
                                 :value="hours"
                                 :key="hours"
                              > {{ windowTimeLabel(hours) }}
                              </option>
                           </select>
                        </div>
                     </div>
                     <small class="text-muted">
                        {{ $t('account_page_facility_checkin_operation.window_time_description_text') }}
                     </small>
                  </div>
               </div>
            </div>
            <!-- END Check-in Time form -->

            <hr>
            <!-- Check-in Date Restriction -->
            <div>
               <h5>{{ $t('account_page_facility_checkin_operation.date_restriction_title') }}</h5>
               <p>{{ $t('account_page_facility_checkin_operation.date_restriction_description_text') }}</p>
            </div>

            <div class="container">
               <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12">
                     <div class="d-flex flex-row align-center mt-2">
                        <div>
                           {{ $t('account_page_facility_checkin_operation.date_restriction_label') }}
                        </div>
                        <div class="pl-2 d-flex flex-row align-self-center">
                           <toggle-button
                              v-model="checkinSettingData.date_restriction"
                              :labels="{ checked: 'On', unchecked: 'Off' }"
                              :value="checkinSettingData.date_restriction"
                              :sync="true"
                           />
                        </div>
                     </div>
                  </div>
               </div>

               <div class="row mt-5">
                  <div class="col-lg-12" align="center">
                     <button
                        :disabled="isInvalidCheckinTimeSetting"
                        type="submit"
                        class="btn btn-primary ml-3"
                     >
                        {{ $t('account_page_facility_checkin_operation.confirm_button') }}
                     </button>
                  </div>
               </div>
            </div>
            <!-- END Check-in Date Restriction -->

         </form>

      </div>
   </section>
</template>
